module.exports = __webpack_public_path__ + "static/media/logo-carrorama-fleet.ba1186e3.jp2";